import { config } from "@/lib/config";

export default function Scroll() {
  const items = [];
  for (let i = 1; i <= 8; i++) {
    items.push(
      <div key={`scroll-item-${i}`} className={`item item${i}`}>
        <img
          src={`${config.basePath}/images/scroll/scroll-${i}.webp`}
          alt={`BeArt ${i}`}
          className="lazyload"
          width={400}
          height={200}
        />
      </div>,
    );
  }
  return <div className="scroll-wrapper">{items}</div>;
}
